<template>
  <Ctx />
</template>

<script>
import Ctx from './ctxWrap/index.vue'
export default {
  components: {
    Ctx
  }
}
</script>
